<div class="pathway-page-wrapper" [class.pathway-completed-bg]="isEnrollmentCompleted">
  <app-pathway-detail-header
    [completedAt]="completedAt"
    (pathwayName)="pathwayName = $event"
  ></app-pathway-detail-header>

  <app-pathway-details
    [pathwayName]="pathwayName"
    (enrollmentLoaded)="onEnrollmentLoaded($event)"
  ></app-pathway-details>
</div>

